// extracted by mini-css-extract-plugin
export default {"container":"FollowCard_container__LSWMh","card_chip":"FollowCard_card_chip__33k8N"};